// extracted by mini-css-extract-plugin
export var icon = "_ae-3";
export var subtitle = "_ae-2";
export var title = "_ae-1";
export var value = "_ae-0";